import { createSelector } from 'reselect';

export const mapLocale = createSelector(
  state => state.intl.locale,
  locale => (locale === 'ru' ? 'ru_RU' : 'en_US'),
);
